import NewsArticleContentContainer from "containers/NewsAndArticles/NewsArticleContent";

const NewsAndArticleContent = (props) => {
    return <NewsArticleContentContainer {...props} />;
}

export default NewsAndArticleContent;